import {
  classNames,
  Flex,
  FlexCenter,
  FlexColumn,
  tv,
  type VariantProps,
} from "@opensea/ui-kit"
import { FilterSidePanelToggle } from "./FilterSidePanelToggle"

const filterLayoutToolbarVariants = tv({
  slots: {
    container: "",
    toolbarContainer: "scrollbar-hidden",
    toolbar: "w-full gap-3",
  },
  variants: {
    variant: {
      page: {
        container: "w-[stretch] bg-bg-app",
        toolbarContainer: "w-full px-0",
        toolbar: "min-h-filter-toolbar items-center bg-bg-app py-4 lg:py-0",
      },
      heroHeader: {
        container: "lg:bg-bg-app",
        toolbarContainer: "min-h-filter-toolbar",
        toolbar: "h-8",
      },
    },
  },
})

export type FilterLayoutToolbarProps = {
  children?: React.ReactNode
  afterToolbar?: React.ReactNode
  contentHeader?: React.ReactNode

  variant?: VariantProps<typeof filterLayoutToolbarVariants>["variant"]

  pills?: React.ReactNode
  pillsLayout?: "vertical" | "horizontal"

  showSidePanelToggle?: boolean

  className?: string
  toolbarContainerClassName?: string
  pillsContainerClassName?: string
}

export function FilterLayoutToolbar({
  children,
  contentHeader,
  variant = "page",
  pills,
  pillsLayout = "vertical",
  showSidePanelToggle = true,
  className,
  toolbarContainerClassName,
  afterToolbar,
  pillsContainerClassName,
}: FilterLayoutToolbarProps) {
  const { container, toolbarContainer, toolbar } = filterLayoutToolbarVariants({
    variant,
  })

  return (
    <FlexColumn className={classNames(container(), className)}>
      <FlexCenter
        className={classNames(toolbarContainer(), toolbarContainerClassName)}
      >
        <Flex className={toolbar()}>
          {showSidePanelToggle ? <FilterSidePanelToggle /> : null}
          {pillsLayout === "horizontal" ? pills : null}
          {children}
        </Flex>
      </FlexCenter>

      {afterToolbar}

      <FlexCenter className={pillsContainerClassName}>
        {pillsLayout === "vertical" ? pills : null}
      </FlexCenter>

      {contentHeader ? (
        <FlexCenter className="gap-4 pt-4">{contentHeader}</FlexCenter>
      ) : null}
    </FlexColumn>
  )
}
